import React, { useMemo, useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './MonitoringCenterAssignedDoctorColumn.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import CaseForwarderModal from '../../../Case/Components/CaseForwarder/CaseForwarderModal';
import { MonitoringCenterCase } from '../MonitoringCenterListTable/MonitoringCenterListTable';

interface Props {
	item: MonitoringCenterCase;
	onRefresh: () => void;
}

const MonitoringCenterAssignedDoctorColumn: React.FC<Props> = ({
	item,
	onRefresh,
}) => {
	const [isCaseForwarderOpen, setIsCaseForwarderOpen] = useState(false);

	const handleAfterCaseReAssign = () => {
		setIsCaseForwarderOpen(false);
		onRefresh();
	};

	const component = useMemo(() => {
		if (item?.doctor?.id && item.assignedDoctorShortedName) {
			return (
				<LinkButton
					title={item.assignedDoctorShortedName}
					theme={Theme.BLUE}
					onClick={() => setIsCaseForwarderOpen(true)}
					className={styles.assignButton}
				/>
			);
		}

		return (
			<LinkButton
				title='component.monitoringCenter.notAssigned'
				theme={Theme.RED}
				onClick={() => setIsCaseForwarderOpen(true)}
			/>
		);
	}, [item]);

	return (
		<>
			{component}
			{isCaseForwarderOpen && (
				<CaseForwarderModal
					opened={isCaseForwarderOpen}
					caseId={item.id}
					onSuccess={handleAfterCaseReAssign}
					onClose={() => setIsCaseForwarderOpen(false)}
				/>
			)}
		</>
	);
};

export default MonitoringCenterAssignedDoctorColumn;
